"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amplify = void 0;
const app_1 = require("@koopajs/app");
const aws_amplify_1 = require("aws-amplify");
const lodash_1 = require("lodash");
class Amplify extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'amplify';
        const dispatch = this.useDispatch();
        app_1.Bus.onConfigReady(async ({ amplify }) => {
            if (lodash_1.isEmpty(amplify)) {
                return console.warn('Amplify plugin was loaded but config was not received from backend.');
            }
            aws_amplify_1.default.configure(amplify);
            try {
                const user = await aws_amplify_1.default.Auth.currentAuthenticatedUser();
                const jwt = user.signInUserSession.idToken.jwtToken;
                await app_1.Operations.Session.login(dispatch)(jwt);
            }
            catch (_a) {
                await app_1.Operations.Session.logout(dispatch)();
            }
        });
        aws_amplify_1.Hub.listen('auth', async ({ payload }) => {
            if (payload.event === 'signIn') {
                const jwt = payload.data.signInUserSession.idToken.jwtToken;
                await app_1.Operations.Session.login(dispatch)(jwt);
            }
            else if (payload.event === 'signOut') {
                await app_1.Operations.Session.logout(dispatch)();
            }
        });
        aws_amplify_1.default.Analytics.autoTrack('pageView', {
            enable: true,
            eventName: 'pageView',
            type: 'SPA'
        });
        app_1.Bus.onAnalytics(({ eventName, args, value }) => {
            const metrics = value ? { value } : {};
            aws_amplify_1.default.Analytics.record({
                metrics,
                name: eventName,
                attributes: args
            });
        });
    }
}
exports.Amplify = Amplify;
//# sourceMappingURL=index.js.map